/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type RailTag_tag = {
    readonly name: string | null;
    readonly similarItems: {
        readonly searchUrl: string | null;
        readonly category: {
            readonly name: string | null;
        } | null;
        readonly creator: {
            readonly name: string | null;
        } | null;
        readonly items: ReadonlyArray<{
            readonly pdpURL: string | null;
            readonly title: string | null;
            readonly photos: ReadonlyArray<{
                readonly versions: ReadonlyArray<{
                    readonly webPath: string | null;
                } | null> | null;
            } | null> | null;
        } | null> | null;
    } | null;
    readonly " $refType": "RailTag_tag";
};
export type RailTag_tag$data = RailTag_tag;
export type RailTag_tag$key = {
    readonly " $data"?: RailTag_tag$data;
    readonly " $fragmentRefs": FragmentRefs<"RailTag_tag">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "kind": "Fragment",
  "name": "RailTag_tag",
  "type": "TradePhotoTag",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "similarItems",
      "storageKey": null,
      "args": null,
      "concreteType": "SimilarItemsResults",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "searchUrl",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "category",
          "storageKey": null,
          "args": null,
          "concreteType": "Category",
          "plural": false,
          "selections": (v1/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "creator",
          "storageKey": null,
          "args": null,
          "concreteType": "Creator",
          "plural": false,
          "selections": (v1/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "items",
          "storageKey": null,
          "args": null,
          "concreteType": "Item",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "pdpURL",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "photos",
              "storageKey": "photos(limit:1)",
              "args": [
                {
                  "kind": "Literal",
                  "name": "limit",
                  "value": 1
                }
              ],
              "concreteType": "ItemPhoto",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "versions",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ItemPhotoVersion",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "webPath",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '3c025cfd00b346e8179784444cc040b6';
export default node;
